// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"71e9faee","667":"6f689dc6","977":"a40276da"}[chunkId] + ".chunk.js";
};